// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3dOva","footer":"Form_footer__1Wa9f"};